import { Component } from 'react'
import Link from 'next/link'
import NotificationMenu from 'components/NotificationMenu'
import Router from 'next/router'
import { IonIcon, Button, Modal } from 'controls'
import { Row, Col } from 'flexbox'
import { header } from './styles'
import { connect } from 'react-redux'
import { utils } from 'services'
import { image } from 'services'
import ShoppingCardIcon from 'components/PropertyHighlight/ShoppingCardIcon'
import ContractFeaturesFlag from 'components/ContractFeaturesFlag'
import { CONTRACT_FEATURES } from 'app/constants/contractFeatures'
import { checkFeatureFlag } from 'config'

import TeamAssistantInfoRemainder from './TeamAssistantInfoRemainder'
import {
  NexiShopLink,
  HestiaLink,
  NexicreditLink,
  SogoEmailLink,
  CrmHighLevelLink,
} from './CommonLinks'



const ON_BOARDING_STATUS = ['CREATED', 'PENDING', 'VERIFIED', 'PENDING_VALIDATION', 'REJECTED']


class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openModal: false
    }
  }

  getUserAvatarStyles = () => {
    const { avatar } = this.props.userInfo
    if (!avatar) {
      return {}
    }
    return {
      backgroundImage: `url("${utils.getThumbnail({
        file: avatar,
        sizeName: 'avatar'
      })}")`,
      backgroundSize: 'cover'
    }
  }

  getUserInitials = () => {
    const { firstName, lastName, avatar } = this.props.userInfo

    if (avatar) {
      return null
    }

    if (!firstName || !lastName) {
      return 'KG'
    }

    return `${firstName.substr(0, 1)}${lastName.substr(0, 1)}`.toUpperCase()
  }
  closeModal = () => this.setState({ openModal: false })
  exit = () => this.setState({ openModal: true })
  logout = () => {
    window.location.assign('/salir')
  }

  render() {
    const { openModal, closeModal } = this.state
    const { canSeeMenu } = this.props

    return (
      <div>
        <Modal isOpen={openModal} onClose={this.closeModal}>
          <div style={{ textAlign: 'center', padding: '2rem' }}>
            <h1>¿Esta seguro que desea salir? </h1>
            <Row>
              <Col xs={6} sm={4} smOffset={1}>
                <Button
                  color="primary"
                  fullWidth
                  outline
                  onClick={this.closeModal}
                >
                  Cancelar
                </Button>
              </Col>
              <Col xs={6} sm={4} smOffset={2}>
                <Button color="primary" fullWidth outline onClick={this.logout}>
                  Aceptar
                </Button>
              </Col>
            </Row>
          </div>
        </Modal>
        <header>
          <ul className="menus">
            {checkFeatureFlag('show-on-hl-integration') && (
              <li className="hideOnMobile">
                <Link href="/dashboard/calendar">
                  <a className="hide-text-on-mobile">
                    <IonIcon size="small" icon="md-calendar" />
                    <span>Calendario</span>
                  </a>
                </Link>
              </li>
            )}
            <li className="hideOnMobile">
              <SogoEmailLink hideTextOnMobile />
            </li>

            <li className="hideOnMobile">
              <TeamAssistantInfoRemainder>
                <Button
                  className="hideOnMobile hide-text-on-mobile"
                  style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', height: 'auto' }}
                  size="tiny"
                  href="/dashboard/team-assistant"
                >
                  <IonIcon
                    size="small"
                    icon="md-help-buoy"
                    className="hideOnMobile"
                  />
                  <span>Soporte</span>
                </Button>
              </TeamAssistantInfoRemainder>
            </li>
            <li className="hideOnMobile">
               <CrmHighLevelLink hideTextOnMobile />
             </li>
            <li className="hideOnMobile">
              <HestiaLink />
            </li>
            <li className="hideOnMobile">
              <NexicreditLink hideTextOnMobile />
            </li>
            <li className="hideOnMobile">
              <NexiShopLink hideOnMobile hideTextOnMobile />
            </li>
            <li>
              <span>|</span>
              <NotificationMenu />
              <span>|</span>
            </li>
            <ContractFeaturesFlag
              contractFeature={CONTRACT_FEATURES.PROPERTY_HIGHLIGHT_ON_DEMAND}
            >
              <li>
                <ShoppingCardIcon />
              </li>
            </ContractFeaturesFlag>
            <li>
              <span
                className="user-initials"
                style={this.getUserAvatarStyles()}
              >
                {this.getUserInitials()}
              </span>
              <IonIcon size="small" icon="ios-arrow-down" />
              {canSeeMenu && (
                <ul>
                  <li onClick={() => Router.push('/dashboard/profile')}>
                    <IonIcon size="small" icon="md-person" />
                    <span>Mi Perfil</span>
                  </li>

                  <li className="showOnMobile">
                    <a href="https://www.hestiaplp.com.mx" target="_blank">
                      <IonIcon size="small" icon="ios-bookmarks" />
                      <span>Póliza Hestia</span>
                    </a>
                  </li>

                  <li
                    className="showOnMobile"
                  >
                    <Link
                      href="/dashboard/team-assistant"
                    >
                      <a>
                        <IonIcon size="small" icon="md-help-buoy" />
                        <span>Soporte</span>
                      </a>
                    </Link>
                  </li>
                  <li className='showOnMobile'>
                     <SogoEmailLink  />
                  </li>
                  <li className="showOnMobile">
                     <CrmHighLevelLink  />
                  </li>
                  <li onClick={() => Router.push('/dashboard/payments')}>
                    <IonIcon size="small" icon="md-bookmarks" />
                    <span>Pagos y facturación</span>
                  </li>
                  <li className="faqs">
                    <Link href="/help/legal">
                      <a>
                        <img
                          src={image('/icons/question.svg')}
                          alt="Hestia"
                          style={{ marginLeft: '1rem', maxWidth: '1.1rem' }}
                        />
                        <span>FAQs</span>
                      </a>
                    </Link>
                  </li>
                  <li className="contract">
                    <Link
                      href="dashboard/myPropertyDocument"
                      as="/dashboard/property-document/my-documents"
                    >
                      <a>
                        <IonIcon size="small" icon="ios-book" />
                        <span>Mis Documentos</span>
                      </a>
                    </Link>
                  </li>
                  <li className="showOnMobile">
                    <NexicreditLink />
                  </li>

                  <li onClick={this.exit}>
                    <IonIcon size="small" icon="ios-log-out" />
                    <span>Cerrar Sesión</span>
                  </li>
                </ul>
              )}
            </li>
          </ul>
          <style jsx>{header}</style>
        </header>
      </div>
    )
  }
}


const mapStateToProps = state => ({
  userInfo: state.auth.profile,
  canSeeMenu: !ON_BOARDING_STATUS.includes(state.auth.profile.status),
})

export default connect(mapStateToProps)(Header)
